var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleteTickIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.97 7.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "0.32 3.71 0.32 3.71 0.32 3.71 0.32 3.71",
    style: {
      fill: "#ee9321"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71,1.46h0A1.06,1.06,0,0,0,9,1.14a1,1,0,0,0-.71.28h0l-5,5L1.76,4.85h0A1.06,1.06,0,0,0,1,4.56a1.05,1.05,0,0,0-.7.28A1,1,0,0,0,0,5.59a1.06,1.06,0,0,0,.28.71h0L2.59,8.59l0,0h0a1,1,0,0,0,.64.25A1,1,0,0,0,4,8.56H4L9.7,2.88h0a1,1,0,0,0,.28-.7A1.08,1.08,0,0,0,9.71,1.46Z",
    transform: "translate(-0.01 -1.14)",
    style: {
      fill: "#ee9321"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteTickIcon);
export default __webpack_public_path__ + "static/media/complete_tick_icon.91731248aa21fbf744c1c86de0234b25.svg";
export { ForwardRef as ReactComponent };